export default class Hero {
  constructor() {
    this.selector = '.b-hero';

    this.selectors = {
      cta: '.col-text .c-button',
    };

    this.nodes = {};
  }

  bootstrap() {
    const blocks = [ ...document.querySelectorAll(this.selector) ];

    if (blocks.length === 0) {
      return;
    }

    blocks.forEach(block => {
      if (block.classList.contains('b-hero-style-about-us')) {
        return;
      }

      this.getNodes({ block });
      this.init();
    });
  }

  getNodes({ block }) {
    this.nodes = {
      cta: block.querySelector(this.selectors.cta),
    };
  }

  // eslint-disable-next-line class-methods-use-this
  init() {
    window.addEventListener('load', () => {
      // Animate the gradient CTA
      let x = 0;
      const interval = setInterval(move, 20); // eslint-disable-line no-use-before-define
      const { cta } = this.nodes;

      // Animations
      function move() { // eslint-disable-line func-style
        if (x === 200) {
          clearInterval(interval);
          cta.classList.remove('is-animating');
          cta.classList.add('is-animated');
        } else {
          x += 1;
          cta.style.backgroundImage = `linear-gradient(90deg, #4275e9 0%, #49afdb ${x - 100}%)`;
        }
      }
    });
  }
}
